import {gql} from "apollo-angular";



const GET_CLOSURES = gql`
query closures($isDeleted: Boolean = false, $isActive: Boolean = null, $isFictive: Boolean = false, $exercice_Id_In: ID) {
  closures(
    isDeleted: $isDeleted
    isActive: $isActive
    orderBy: "-end_date"
    isFictive: $isFictive
    exercice_Id_In: $exercice_Id_In
  ) {
    edges {
      node {
        id
        endDate
        startDate
        isActive
        isFictive
        exercice {
          endDate
          startDate
          name
        }
        createdDate
        addedBy {
          firstName
          lastName
        }
        updatedDate
        updatedBy {
          firstName
          lastName
        }
      }
    }
  }
}
`


export {GET_CLOSURES}



